import { useEffect, type FC, type ReactNode } from 'react';

import { useSettings } from 'src/hooks/use-settings';

import { useSections } from './config';
import { HorizontalLayout } from './horizontal-layout';
import { VerticalLayout } from './vertical-layout';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import {
  callAutoClockOutAction,
  getTimeCheckInAction,
} from 'src/redux/actions/therapist-dashboard-action';
import {
  convertDateToFacilityDate,
  convertIntoIsoFormat,
} from 'src/utils/convertDateToSelectedTimeZone';
import useCurrentUser from 'src/hooks/use-current-user';

interface LayoutProps {
  children?: ReactNode;
}

export const Layout: FC<LayoutProps> = (props) => {
  const settings = useSettings();
  const sections = useSections();
  const dispatch = useDispatch();
  const [providerId] = useCurrentUser(['providerId']);

  useEffect(() => {
    const currentTime = new Date();
    const dateTimeAccordingToFacility = convertDateToFacilityDate(currentTime);
    const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';

    // const formattedDate = moment(currentDate).format('YYYY-MM-DD');
    const isCheckIn = localStorage.getItem('isCheckIn') === 'true';
    if (!!providerId && !isCheckIn) {
      dispatch(
        getTimeCheckInAction({
          providerId,
          date: convertIntoIsoFormat(dateTimeAccordingToFacility),
          zoneTime: getFacilityTimeZone,
        })
      );
    }
    dispatch(
      callAutoClockOutAction({
        date: convertIntoIsoFormat(dateTimeAccordingToFacility),
        zoneTime: getFacilityTimeZone,
      })
    );
  }, [providerId]);

  if (settings.layout === 'horizontal') {
    return (
      <HorizontalLayout
        sections={sections}
        navColor={settings.navColor}
        {...props}
      />
    );
  }

  return (
    <VerticalLayout
      sections={sections}
      navColor={settings.navColor}
      {...props}
    />
  );
};
